import {
  flattenErrorTypeArray,
  ModelForm,
  useCreateAndAddRefs,
} from '@equifinance/shared';
import { useProductsContext } from '../../contexts';
import General from '../Account/Sections/LoanDetails/General';
import Fees from '../Account/Sections/LoanDetails/Fees';
import PropertyValue from './PropertyValue';
import { SectionTitleIcon } from '../Account/Icons/SectionTitleIcon';
import { PaddedSection } from '../Account/components/Section';

const ProductsLoanDetailsRefName = 'products-loan-details';

export default function ProductsLoanDetails() {
  const ref = useCreateAndAddRefs(ProductsLoanDetailsRefName);

  const {
    productLoanDetails, updateProductLoanDetails,
  } = useProductsContext();

  const {
    loanDetails, property, errors, warnings,
  } = productLoanDetails;
  const { fees } = loanDetails ?? {};
  const {
    BrokerFee, ValuationFee, AdviceFee,
  } = fees ?? {};

  const allErrors = flattenErrorTypeArray([
    ...(errors?.[loanDetails?.id] ?? []),
    ...(errors?.[property?.id] ?? []),
    ...(errors?.[BrokerFee?.id] ?? []),
    ...(errors?.[ValuationFee?.id] ?? []),
    ...(errors?.[AdviceFee?.id] ?? []),
  ]);

  const update = (values: Record<string, any>, disableIncrementUpdateCount: boolean = false) => {
    Object.entries(values).forEach(([field, value]) => {
      updateProductLoanDetails(field, value, disableIncrementUpdateCount);
    });
  };

  return (
    <ModelForm model={productLoanDetails} update={update} errors={errors} warnings={warnings}>
      <div id={ProductsLoanDetailsRefName} ref={ref}>
        <PaddedSection
          id="loan-details"
          title="Loan Details"
          titleIcon={<SectionTitleIcon errors={allErrors} />}
        >
          <>
            <PropertyValue />
            <General loanDetails={loanDetails} errors={errors} warnings={warnings} />
            <Fees loanDetails={loanDetails} />
          </>
        </PaddedSection>
      </div>
    </ModelForm>
  );
}
